import { Component, Inject, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  CONSTANT,
  FileUploadService,
  LoaderService,
  ObservableService,
  OrderService,
  PdfGeneratorService,
} from '@bst-frontend/shared';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
export type VehicleAssignMode = 'create' | 'edit' | 'view';

@Component({
  selector: 'bst-frontend-assign-driver-modal',
  templateUrl: './assign-driver-modal.component.html',
  styleUrls: ['./assign-driver-modal.component.css'],
})
export class AssignDriverModalComponent {
  @Input() mode: VehicleAssignMode = 'create';
  @Input() initialData?: any;
  @Input() subOrder?: any;

  form!: FormGroup;
  loading = false;

  get isViewMode() {
    return this.mode === 'view';
  }

  @Input() orderData: any;
  vehicleTypeList: any = [{ _id: 1, name: 'Truck' }];
  driverList: any = [];
  vehicleList: any = [];
  companyAddresses: any = [];
  orderTruckDetailForm!: FormGroup;
  selectedTruck: any;
  uploadedFileKey: string | null = null;
  uploadedFileSize: number | null = null;
  lrNumber = '';
  today = new Date();
  constructor(
    private activeModal: NgbActiveModal,
    private orderService: OrderService,
    private fb: FormBuilder,
    private loader: LoaderService,
    private observableService: ObservableService
  ) {}

  async ngOnInit() {
    this.loader.show();
    this.buildForm();
    Promise.all([
      this.getCompanyAddress(),
      this.getDriverList(),
      this.getVehicleList(),
    ]).finally(() => {
      this.loader.hide();
    });

    if (this.initialData) {
      this.form.patchValue({
        vehicleType: this.initialData.vehicleType,
        tempoId: this.initialData.tempoId,
        driverId: this.initialData.driverId,
        notes: this.initialData.notes,
      });
    }

    if (this.isViewMode) {
      this.form.disable();
    }
  }

  private buildForm() {
    this.form = this.fb.group({
      vehicleType: [this.vehicleTypeList[0]?.name, Validators.required],
      tempoId: ['', Validators.required],
      driverId: ['', Validators.required],
      deliveryAddress: ['', Validators.required],
      notes: [''],
    });
  }

  async getDriverList() {
    try {
      const res: any = await this.orderService.getAllDriver().toPromise();
      this.driverList = res.data.docs;
    } catch (error) {
      console.error('Failed to load drivers', error);
    }
  }

  async getVehicleList() {
    try {
      const res: any = await this.orderService.getAllVehicle().toPromise();
      this.vehicleList = res.data.docs;
    } catch (error) {
      console.error('Failed to load vehicles', error);
    }
  }

  async getCompanyAddress() {
    try {
      const res: any = await this.orderService
        .getUserAddresses({ isCompany: true })
        .toPromise();
      this.companyAddresses = res.data.docs;
    } catch (error) {
      console.error('Failed to load vehicles', error);
    }
  }

  // convenience getter
  get f() {
    return this.form.controls;
  }

  markAllTouched() {
    this.form.markAllAsTouched();
  }

  async save() {
    if (this.form.invalid) {
      this.markAllTouched();
      return;
    }

    // Required fields
    const vehicleType = this.f['vehicleType'].value;
    const driverId = this.f['driverId'].value;
    const tempoId = this.f['tempoId'].value;
    const notes = this.f['notes'].value;
    const deliveryAddress = this.f['deliveryAddress'].value;

    // Assemble final payload
    const payload = {
      driverDetails: {
        driverId,
        tempoId,
        deliveryAddress: this.companyAddresses.find(
          (addr: any) => addr._id === deliveryAddress
        ),
      },
      vehicleType,
      notes: notes,
    };

    this.loader.show();
    try {
      await this.orderService
        .updateSubOrder(
          CONSTANT.orderStatus['ASSIGN-DRIVER'],
          this.subOrder._id,
          payload
        )
        .toPromise();
      this.observableService.send({ refresh: true });
      // this.loader.hide();
      this.activeModal.close({ status: 'saved' });
    } catch (error) {
      console.log('Error', error);
    }

  }

  cancel() {
    this.activeModal.dismiss('cancel');
  }
}
